import { Component, EventEmitter, Input, OnInit, OnChanges, Output, Injector, OnDestroy, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Product, ProductItemModel } from 'src/app/shared/models/product.model';
import { TBSBaseComponent } from 'src/app/shared/models/tbsBaseComponent';
import { ChildComponentOptions } from 'src/app/shared/models/childComponentOptions.model';
import { interval, take, Subject, of, map, switchMap, takeUntil } from 'rxjs';
import { IEditableMBRSiteToolbar } from 'src/app/shared/editable-mbr-site-toolbar/editable-mbr-site-toolbar.model';
import { SelfServiceService } from 'src/app/modules/self-service/self-service.service';
import { SelfServiceManageProductTemplateModalComponent } from 'src/app/shared/self-service-templates/self-service-manage-product-template-modal/self-service-manage-product-template-modal.component';
import { SelfServiceModel } from 'src/app/shared/models/selfService.model';
import { SelfService } from 'src/app/shared/models/constants';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { SelfServiceDeleteTemplateModalComponent } from 'src/app/shared/self-service-templates/self-service-delete-template-modal/self-service-delete-template-modal.component';
import { CommonPageModel } from 'src/app/shared/models/commonPage.model';
import { ContentItemModel } from 'src/app/shared/models/contentItem.model';
import { FolderTypeModel } from 'src/app/shared/models/folderType.model';
import { SystemTypeModel } from 'src/app/shared/models/systemType.model';
import { SaveResultWithData, SaveResult } from 'src/app/shared/models/saveResult.model';
import { ManagementRightService } from 'src/app/modules/self-service/management-right.service';
import { ResourceString } from 'src/app/shared/models';
import { SelfServiceWysiwygEditorToolbar } from 'src/app/shared/self-service-templates/self-service-wysiwyg-editor-form/self-service-wysiwyg-editor-toolbar-settings';
import { EditableMbrSiteToolbarService } from 'src/app/shared/editable-mbr-site-toolbar/editable-mbr-site-toolbar.service';
import { EditorContentAccessScope } from 'src/app/shared/models/editor-content-access-scope.enum';

@Component({
  selector: 'app-masthead-benefits',
  templateUrl: './masthead-benefits.component.html',
  standalone: false
})
export class MastheadBenefitsComponent extends TBSBaseComponent implements OnInit, OnDestroy, OnChanges {
  campaignKey: string;
  @Output() collapseBenefitMenu: EventEmitter<any> = new EventEmitter();
  @Output() dropdownState: EventEmitter<boolean> = new EventEmitter();
  @Output() refreshBenefitsEvent: EventEmitter<void> = new EventEmitter();
  @Input() benefits: Array<{
    categoryName: string,
    icon: string,
    icon2: string,
    groupBenefits: Product[];
  }>;
  @Input() resourcestrings;
  @Input() closeBenefit;
  baseUrl: string;
  categoryToggle: boolean = false;
  showAllForCategory: string;
  active = 0;
  categoryIndex: number;
  categorySection = [];
  entityToolbarControl: IEditableMBRSiteToolbar.Controls;
  ContentManagedBy = IEditableMBRSiteToolbar.ManagedBy;
  instanceToolbarControl: { [key: string]: IEditableMBRSiteToolbar.Controls } = {};

  constructor(
    private readonly injector: Injector,
    private readonly router: Router,
    private readonly elementRef: ElementRef,
    private readonly selfService: SelfServiceService,
    private readonly ngxService: NgxUiLoaderService,
    private readonly ManagementRightService: ManagementRightService,
    private readonly editableMbrSiteToolbarService: EditableMbrSiteToolbarService
  ) {
    super(injector, new ChildComponentOptions(true, true, false));
  }
  ngOnChanges() {

    if (this.closeBenefit) {
      this.showAllForCategory = null;
    }

    // Load Self Service Toolbar Controls
    this.loadSelfServiceToolbarControls();
  }
  ngOnInit(): void {
    this.campaignKey = this.helperService.getCampaignKey();
    this.baseUrl = this.helperService.getBaseUrl();
    this.addResourceStringKeys(this.resService.mastheadStringKeys);
    this.addResourceStringKeys(this.resService.homeStringKeys);
    this.loadResourceStringAsObservable()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(res => {
        this.getResouceStringsAsObject(res);

      })

    this.ManagementRightService.refreshContentSubject
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(status => {
        if (status) {
          this.refreshBenefitsEvent.emit();

        }        // Handle transfer status updates
      });
  }

  private loadSelfServiceToolbarControls() {
    const allProductItemModel = [];
    if (this.helperService.isInternalEditorSite) {
      this.benefits.forEach(element => {
        if (element.groupBenefits.length > 0) {
          element.groupBenefits.forEach(gb => {
            const pItem = this.selfService.convertProductTypeToProductItemModel(gb)
            allProductItemModel.push(pItem);
          })
        }
      });
    }

    this.entityToolbarControl = this.editableMbrSiteToolbarService.buildEntityToolbarControls({
      ownershipManagementEnabled: true,
      groupControls: [
        {
          groupCode: "BASIC_CONTROL",
          groupName: this.resourcestrings['Aon.SelfService.MastheadBenefits.EntityToolbar.BasicControls.GroupName'],
          controls: [
            {
              action: "ADD",
              callBackFn: this.addProduct
            }
          ]
        }
      ],
      entityChildContents: allProductItemModel
    });

    this.benefits.forEach(benefitCategory => {
      benefitCategory.groupBenefits.forEach(product => {
        const ProductItemModel = this.selfService.convertProductTypeToProductItemModel(product);
        this.instanceToolbarControl[product.nodeGUID] = this.editableMbrSiteToolbarService.buildInstanceToolbarControls({
          ownershipManagementEnabled: true,
          isGatewayContentParentNode: true,
          content: ProductItemModel,
          groupControls: [
            {
              groupCode: "BASIC_CONTROL",
              groupName: this.resourcestrings['Aon.SelfService.MastheadBenefits.InstanceToolbar.BasicControls.GroupName'],
              controls: [
                {
                  action: "EDIT",
                  callBackFn: this.editProduct,
                  args: [product]
                },
                {
                  action: "DELETE",
                  callBackFn: this.deleteProduct,
                  args: [product]
                },
                {
                  action: "RESTORE",
                  callBackFn: this.updateSoftDeleteFlag,
                  args: [ProductItemModel, false]
                },
                {
                  action: "FORCE_DELETE",
                  callBackFn: this.deleteProduct,
                  args: [product]
                }
              ]
            },
            {
              groupCode: "MANAGE_CHILD_CONTENT",
              groupName: this.resourcestrings['Aon.SelfService.MastheadBenefits.InstanceToolbar.ContentManagement.GroupName'],
              controls: [
                {
                  action: "VIEW",
                  callBackFn: this.viewProduct,
                  args: [product]
                }
              ]
            }
          ]
        });
      })
    })
  }

  ngOnDestroy(): void {
    this.signalUnsubscribe();
  }

  navigateToProductDetail(product: Product): void {
    let lineId = product.line_GUID;
    if (this.helperService.isSelfServiceSite) {
      lineId = product.nodeGUID;
    }
    sessionStorage.setItem('IsFromBenefitNavMegaMenu', 'true');
    this.router.navigate([this.baseUrl + '/product/' + lineId + '/detail']);
    this.collapseBenefitMenu.emit();
  }

  // Callback function for Self Service Toolbar 'View' control
  private viewProduct(product: Product): void {
    this.navigateToProductDetail(product);
  }

  showAllCards(categoryName: string, i): void {

    if (this.showAllForCategory == categoryName) {
      this.showAllForCategory = null;
    }
    else {
      this.showAllForCategory = categoryName;
    }

    // for accessibility to work properly - restore focus to the 5th card when 'Show All' has been triggered.
    interval(0).pipe(take(1)).subscribe((data) => {
      let a: NodeListOf<HTMLElement> = this.elementRef.nativeElement.querySelectorAll('.group-benefit-cards-5');
      a.forEach(item => {
        item.focus()
      })
    })

  }

  showCategory(value) {
    this.categoryToggle = value;
  }

  setCategoryIndex(value, event: Event) {
    this.categoryToggle = !(this.categoryToggle && this.categoryIndex == value);
    this.categoryIndex = value;

    let el = event.target as HTMLElement;
    if (el) {
      setTimeout(() => {
        if (screen.width < 992)
          el.scrollIntoView();
      }, 50);
    }
  }

  // Callback function for Self Service Toolbar 'Add' control
  private addProduct(): void {
    const modalRef = this.selfService.openModal(SelfServiceManageProductTemplateModalComponent, this.resourcestrings['Aon.SelfService.MastheadBenefits.AddProduct.ModalPopup.HeaderLabel'], "lg");
    const componentInstance: SelfServiceManageProductTemplateModalComponent = modalRef.componentInstance;
    componentInstance.headerLabel = this.resourcestrings['Aon.SelfService.MastheadBenefits.AddProduct.ModalPopup.HeaderLabel'];
    componentInstance.customRequiredFields = [
      'itemTitle',
      'documentName',
      'productDisplayOrder'
    ];
    componentInstance.itemThumbnailFileUploadPath = SelfService.MediaPaths.Product.CategoryTab;
    componentInstance.itemThumbnail2FileUploadPath = SelfService.MediaPaths.Product.CategorySection;
    componentInstance.duplicateValidationKeys = [
      'documentName'
    ];
    componentInstance.assignWYSIWYGEditorMode = {
      itemSummary: SelfServiceWysiwygEditorToolbar.Mode3
    };
    componentInstance.firstProductInEachCategories = this.firstProductInEachCategories;

    const postProcess = new Subject<string>();
    componentInstance.onFormSubmit = (data, responseSubject) => {
      responseSubject.next({
        product: data.product,
        folderPath: componentInstance.productNodePath,
        folderName: "",
        postProcess: postProcess
      });
    };

    postProcess.subscribe(() => {
      modalRef.dismiss({ canReload: false });

      // Background thread, which creates boiler template for the Products details page and moves it under the newly created product node. This is required to make sure that when user creates a new product and then tries to manage the content for that product, they will see the boilerplate template instead of empty page.
      this.ngxService.start("CREATE_PRODUCT_DETAILS");
      const productNodeAliasPath = componentInstance.product?.system?.nodeAliasPath;

      const commonPage = new CommonPageModel();
      commonPage.system = new SystemTypeModel();
      commonPage.system.documentName = "Items";
      commonPage.pageTitle = "ProductDetails Items";
      commonPage.pageKey = SelfService.PageKeys.Products.productDetailsItems;

      const contentItem = new ContentItemModel();
      contentItem.system = new SystemTypeModel();
      contentItem.system.documentName = "Section-1";
      contentItem.contentItemTitle = "Section 1 Title";
      contentItem.contentItemBody = "Section 1 Content";

      if (this.selfService.editorContentAccessScope === EditorContentAccessScope.PopulationSpecific) {
        contentItem.roleCondition = componentInstance.product.roleCondition;
      }

      this.selfService.addCommonPage(commonPage, productNodeAliasPath, SelfService.PagePaths.Products.productDetailsFolderName).pipe(
        switchMap(commonPageResponse => {
          if (!commonPageResponse.didSave) {
            return of({ errorMessages: commonPageResponse.errorMessages });
          }

          return this.selfService.addContentItem(contentItem, commonPageResponse.data.system.nodeAliasPath.split('/' + commonPageResponse.data.system.nodeAlias)[0], SelfService.PagePaths.Products.productDetailsItemsFolderName).pipe(
            map(contentItemResponse => ({ commonPage: commonPageResponse.data, contentItemResponse }))
          );
        }),
        switchMap((result: {
          commonPage: CommonPageModel;
          contentItemResponse: SaveResultWithData<ContentItemModel>;
          errorMessages: string[];
        }) => {
          if (result?.errorMessages) {
            return of(result);
          }

          if (!result.contentItemResponse?.didSave) {
            return of({ errorMessages: result.contentItemResponse?.errorMessages ?? [this.resourcestrings['Aon.Common.Error']] });
          }

          const updatedCommonPage = result.commonPage;
          updatedCommonPage.related_ContentItems = this.selfService.addNewRelatedNodeGUID(
            result.contentItemResponse.data.system.nodeGUID,
            updatedCommonPage.related_ContentItems
          );

          return this.selfService.updateCommonPage({
            data: updatedCommonPage,
            updatedRelatedContentItems: true
          }).pipe(map(updateResponse => ({ updateResponse })));
        })
      ).subscribe({
        next: (result: {
          updateResponse: SaveResult;
          errorMessages: string[];
        }) => {
          if (result?.errorMessages) {
            console.warn(result.errorMessages);
          } else if (result?.updateResponse && !result.updateResponse.didSave) {
            console.warn(result.updateResponse.errorMessages ?? [this.resourcestrings['Aon.Common.Error']]);
          }
          this.refreshBenefits();
          this.ngxService.stop("CREATE_PRODUCT_DETAILS");
        },
        error: () => {
          console.warn([this.resourcestrings['Aon.Common.Error']]);
          this.refreshBenefits();
          this.ngxService.stop("CREATE_PRODUCT_DETAILS");
        }
      });
    });

    modalRef.dismissed.subscribe(response => {
      this.dropdownState.emit(false);
      if (response?.canReload) {
        this.refreshBenefits();  // Implement reload logic
      }
    });
  }

  // Callback function for Self Service Toolbar 'Edit' control
  private editProduct(product: Product): void {
    const modalRef = this.selfService.openModal(SelfServiceManageProductTemplateModalComponent, this.resourcestrings['Aon.SelfService.MastheadBenefits.EditProduct.ModalPopup.HeaderLabel'], "lg");
    const componentInstance: SelfServiceManageProductTemplateModalComponent = modalRef.componentInstance;
    componentInstance.product = this.selfService.convertProductTypeToProductItemModel(product);
    componentInstance.templateMode = SelfServiceModel.TemplateMode.Edit;
    componentInstance.headerLabel = this.resourcestrings['Aon.SelfService.MastheadBenefits.EditProduct.ModalPopup.HeaderLabel'];
    componentInstance.customRequiredFields = [
      'itemTitle',
      'documentName',
      'productDisplayOrder'
    ];
    componentInstance.itemThumbnailFileUploadPath = SelfService.MediaPaths.Product.CategoryTab;
    componentInstance.itemThumbnail2FileUploadPath = SelfService.MediaPaths.Product.CategorySection;
    const firstProductInEachCategories = this.firstProductInEachCategories;
    componentInstance.isFirstProductInTheCategory = firstProductInEachCategories[product.category.toLocaleLowerCase()]?.nodeGUID === product.nodeGUID;
    componentInstance.firstProductInEachCategories = firstProductInEachCategories;
    componentInstance.duplicateValidationKeys = [
      'documentName'
    ];
    componentInstance.assignWYSIWYGEditorMode = {
      itemSummary: SelfServiceWysiwygEditorToolbar.Mode3
    };

    modalRef.dismissed.subscribe(response => {
      this.dropdownState.emit(false);
      if (response?.canReload) {
        this.refreshBenefits();
      }
    });
  }

  // Callback function for Self Service Toolbar 'Delete' control and 'Final Delete' control  
  private deleteProduct(product: Product): void {
    const modalRef = this.selfService.openModal(SelfServiceDeleteTemplateModalComponent, this.resourcestrings['Aon.SelfService.Product.Delete.Model.HeaderLabel'], "mg");
    const componentInstance: SelfServiceDeleteTemplateModalComponent = modalRef.componentInstance;
    componentInstance.headerLabel = this.resourcestrings['Aon.SelfService.Product.Delete.Model.HeaderLabel'];
    componentInstance.isSoftDeleted = product.isSoftDeleted;

    // Soft Delete
    componentInstance.softDeleteConfirmationReceived.subscribe(() => {
      this.updateSoftDeleteFlag(this.selfService.convertProductTypeToProductItemModel(product), true, (result, isApiError = false) => {
        if (isApiError) {
          componentInstance.onSubmitErrorMessage = this.resourcestrings['Aon.Common.Error'];
          return;
        }

        if (result.didSave) {
          this.dropdownState.emit(false);
          modalRef.dismiss();
        } else {
          componentInstance.onSubmitErrorMessage = result.errorMessages[0];
        }
      })
    })

    // Hard Delete
    componentInstance.deleteConfirmationReceived.subscribe(() => {
      this.ngxService.start("DELETE_PRODUCT_ITEM");
      this.selfService.deleteProductItem(this.selfService.convertProductTypeToProductItemModel(product)).subscribe({
        next: result => {
          this.ngxService.stop("DELETE_PRODUCT_ITEM");
          componentInstance.hardDeleteStatusFlag = result.didSave;
          modalRef.dismissed.subscribe(() => {
            this.dropdownState.emit(false);
            this.refreshBenefits()
          });
        },
        error: () => {
          componentInstance.onSubmitErrorMessage = this.resourceStrings['Aon.Common.Error'];
          this.ngxService.stop("DELETE_PRODUCT_ITEM");
        }
      });
    })
  }

  private updateSoftDeleteFlag(product: ProductItemModel, isSoftDeleted: boolean, customLogic: Function = null): void {
    this.ngxService.start('UPDATE_PRODUCT');
    this.selfService.updateProductItem({
      data: { ...product, isSoftDeleted: isSoftDeleted },
      updateSoftDeleteFlag: true
    }).subscribe({
      next: result => {
        this.ngxService.stop('UPDATE_PRODUCT');
        if (result.didSave) {
          this.dropdownState.emit(false);
          this.refreshBenefits();
        }

        if (customLogic) {
          customLogic(result);
        }
      },
      error: () => {
        if (customLogic) {
          customLogic(null, true);
        }
        this.ngxService.stop("UPDATE_PRODUCT");
      }
    })
  }

  private get firstProductInEachCategories(): { [key: string]: Product } {
    return Object.fromEntries(
      this.benefits
        .filter(benefitCategory => benefitCategory.groupBenefits?.length > 0)
        .map(benefitCategory => [
          benefitCategory.categoryName.toLocaleLowerCase(),
          benefitCategory.groupBenefits[0]
        ])
    )
  }

  public refreshBenefits(): void {
    this.refreshBenefitsEvent.emit();
  }

  onInstanceDropdownStateChange($event) {
    this.dropdownState.emit($event);
  }

  onEntityDropdownStateChange($event) {
    this.dropdownState.emit($event);
  }

  public getResouceStringsAsObject(res: ResourceString[], resolveMacros: boolean = true): void {
    if (this.isCurrentPathRoleEnabled) {
      this.resourceStrings = this.helperService.getResourceStringsWithAdditionalParamAsObject(
        this.combinedRolesOrPopulationsString,
        this.stringKeys,
        res,
        resolveMacros
      );
      return;
    }

    if (this.productId) {
      this.resourceStrings = this.helperService.getResourceStringsWithAdditionalParamAsObject(this.productId, this.stringKeys, res, resolveMacros);
    } else {
      this.resourceStrings = this.helperService.getResouceStringsAsObject(this.stringKeys, res, resolveMacros);
    }
  }

}
